import api from "./client";
import type {
  Order,
  OrderDetail,
  CreateOrderRequest,
  CustomerImageResponse,
  GenerationJob,
} from "@/types/order";

/** 주문 생성 */
export const createOrder = (data: CreateOrderRequest): Promise<OrderDetail> =>
  api.post("/v1/orders", data).then((res) => res.data.data);

/** 내 주문 목록 */
export const getOrders = (): Promise<Order[]> =>
  api.get("/v1/orders").then((res) => res.data.data);

/** 주문 상세 */
export const getOrderDetail = (orderId: string): Promise<OrderDetail> =>
  api.get(`/v1/orders/${orderId}`).then((res) => res.data.data);

/** 내 주문 생성 이미지 조회 */
export const getOrderImages = (
  orderId: string,
): Promise<CustomerImageResponse> =>
  api.get(`/v1/orders/${orderId}/images`).then((res) => res.data.data);

/** 고객 선택 재생성 */
export const customerRegenerateImages = (
  orderId: string,
  imageIdxList: number[],
): Promise<GenerationJob> =>
  api
    .post(`/v1/orders/${orderId}/images/regenerate`, { imageIdxList })
    .then((res) => res.data.data);

/** 고객 이미지 다운로드 (ZIP) */
export const customerDownloadImages = async (
  orderId: string,
  imageIdxList?: number[],
): Promise<void> => {
  const res = await api.post(
    `/v1/orders/${orderId}/images/download`,
    { imageIdxList },
    { responseType: "blob", timeout: 300_000 },
  );
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `order-${orderId}-images.zip`;
  a.click();
  window.URL.revokeObjectURL(url);
};

/** 고객 재생성 상태 폴링 */
export const getCustomerRegenStatus = (
  orderId: string,
): Promise<GenerationJob> =>
  api
    .get(`/v1/orders/${orderId}/images/regenerate/status`)
    .then((res) => res.data.data);
